module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Name",
      "expanded": ""
    }
  }, [_c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Title"
    }
  }, [_c('option', [_vm._v("Mr.")]), _vm._v(" "), _c('option', [_vm._v("Ms.")])]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Name",
      "expanded": ""
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "expanded": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "some@email.com"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60aaebb4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExCombineAddonsGroups.vue
// module id = 1081
// module chunks = 5 227